<template>
  <div @click="showModal()" data-title="Reject">
    <button class="btn btn-danger text-white">
      <font-awesome-icon class="fa-1x text-white" :icon="['fas', 'trash-alt']" />
    </button>

    <b-modal
      ref="rejectRequestModal"
      size="lg"
      centered
      scrollable
      hide-footer
      :title="`Reject Wallet Request - ${request.projectDetails.name}`"
      @hidden="modalHidden"
    >
      <div class="form-group" :class="{ 'form-group--error': $v.rejectionReason.$error }">
        <label for="walletid" class="form__label">
          Rejection Reason
          <span class="text-danger">*</span>
        </label>
        <textarea
          class="form-control"
          name="rejectionreason"
          id="rejectionreason"
          v-model.trim="$v.rejectionReason.$model"
        ></textarea>
        <div
          class="error"
          v-if="!$v.rejectionReason.required && $v.rejectionReason.$error"
        >Rejection Reason is required</div>
      </div>

      <div class="d-flex justify-content-end mt-3">
        <button class="btn btn-danger" @click="RejectRequest">Reject Request</button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { EventBus } from "../EventBus";
import walletService from "../services/walletService";

export default {
  name: "Reject",
  props: ["request"],
  validations: {
    rejectionReason: { required }
  },
  methods: {
    showModal() {
      this.$refs["rejectRequestModal"].show();
    },
    modalHidden() {
      this.rejectionReason = "";
      this.$v.$reset();
    },
    RejectRequest(e) {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        e.target.disabled = true;
        this.$bvModal
          .msgBoxConfirm(
            "Please confirm that you want to Reject Wallet Request",
            {
              size: "sm",
              buttonSize: "sm",
              okVariant: "success",
              cancelVariant: "danger",
              okTitle: "Yes",
              cancelTitle: "No",
              footerClass: "p-2",
              hideHeaderClose: false,
              centered: true
            }
          )
          .then(value => {
            if (value) {
              e.target.disabled = true;
              EventBus.$emit("toast", {
                title: "Details",
                message: "Updating Wallet Request Details",
                variant: "success"
              });
              //   let input = {
              //     Reason: this.rejectionReason
              //   };
              //   let request = {
              //     RejectionDetails: input
              //   };
              walletService
                .RejectWalletRequest(
                  this.request.paymentRequestId,
                  this.rejectionReason
                )
                .then(response => {
                  EventBus.$emit("toast", {
                    title: "Details",
                    message: "Updated Wallet Request Details successfully",
                    variant: "success"
                  });
                  this.$store.commit("updateWalletRequest", response.data.data);
                  this.$refs["rejectRequestModal"].hide();
                })
                .catch(err => {});
            } else {
              e.target.disabled = false;
            }
          });
      }
    }
  },
  data() {
    return {
      rejectionReason: ""
    };
  }
};
</script>